import { isMemberUpdatingSelector } from '../../../redux/user/selectors';

const map = (state) => ({
  isMemberUpdating: isMemberUpdatingSelector.bind(null, state),
});

export default map;
